import { render, staticRenderFns } from "./vendorNewDetail.vue?vue&type=template&id=022b4a73&scoped=true&"
import script from "./vendorNewDetail.vue?vue&type=script&lang=js&"
export * from "./vendorNewDetail.vue?vue&type=script&lang=js&"
import style0 from "./vendorNewDetail.vue?vue&type=style&index=0&id=022b4a73&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022b4a73",
  null
  
)

export default component.exports